import React,{useEffect,useState,useRef} from 'react';
import { v4 as uuid } from 'uuid';
import { Formik, Form } from 'formik';
import FormikControl from '../../../../../components/FormikControls/FormikControl';
import { AddEvalFace } from '../../../Interfaces/interfaces';
import DyButton from '../../../../../components/GlobalComponents/DyButton/DyButton';
import { currentStateOptions, nextStateOptions } from '../../../StataicData';
import { useAddCheckinMeeting } from '../../../Hooks/index';
import ListSelect from '../../../../../components/GlobalComponents/ListSelect/ListSelect';
import { useSelector } from 'react-redux';
import { intaddKrSchema,straddKrSchema } from '../../../StataicData';
import {TextField, Tooltip} from '@mui/material';
import {CircularProgress} from '@mui/material';
// import { Grid,Box,Typography,Divider,Button} from '@mui/material';
import { ObjectiveSelectedFace,krSelectedFace } from '../../../Interfaces/interfaces';
import DyDataGrid from '../../../../../components/GlobalComponents/DyDataGrid/DyDataGrid';
import DyLinearProgress from '../../../../../components/GlobalComponents/DyLinearProgress/DyLinearProgress';
import Assessor from '../../Assessor/Assessor';
// import ButtonGroup from '@mui/material/ButtonGroup';
// import IconButton from '@mui/material/IconButton';
import { ErrorMessage } from 'formik';
import DYToastMessage from "../../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import "../../../../CompanyManagment/Forms/RegisterTenant/Error.css"
import {
  Grid,
  Box,
  Divider,
  Typography,
  useTheme,
  Button,
  Stack,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
// import { useGetTenantPicture, useAddTenantPicture, } from "../../../scenes/CompanyManagment/Hooks";
import Delete from "@mui/icons-material/Delete";
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import { useAddAttachment, useGetKeyResultAttachment, useGetTenantPicture ,useDeleteAttachment} from '../../../../CompanyManagment/Hooks';

interface progValueFace{
  assessmentRate:null|number,
  score:null|number
}

export const CreateAttachmentBAU = (
    {
        cancelo,
        objectiveManiInfo,
        krMainInfo,objectiveId, 
        kresultId,
        afterAddKr,
        onsucces,
        setAddEvalAsyncData,
        setChangeImgData,
        imageSelectedType,
        fillPadd,
        AddButtonVariant,
        addButtonColor,
        directionImageWrap,
        disableSizeText
    }:any) => {
  const meetSelectedDate = useSelector((state: any) => state.meetings.meetSelectedDate);
    const meetingId: any = useSelector((state: any) => state.meetings.meetingId);
    const teamId: any = useSelector((state: any) => state.meetings.teamInfo?.id);
    const periodId: any = useSelector((state: any) => state.meetings.priodId);
    const profileTenantId: any = useSelector((state: any) => state.meetings.profileTenantId);
    // const[initialValuesForm,setInitialValuesForm]=useState<any>({description:''});
    // const[progressFormValues,setProgressFormValues]=useState<progValueFace>({assessmentRate:0,score:0});
    // const[keyResultMeetingHistoryDtos,setKeyResultMeetingHistoryDtos]=useState<any[]>([]);
    // const[assessmentHistory,setAssessmentHistory]=useState<any[]>([]);
    // const {data:initialNewValue,isLoading:iniValLoading}=useGetMeetingKeyResultValueById({meetingId:meetingId,krId:kresultId});
    const[formIds,setFormIds]=useState<any>({meetingId:meetingId,periodId:periodId,keyResultId:null});
    const[tensileScore,setTensileScore]=useState<string|null>('');
    const addKrStatusData:any=useSelector((state:any)=>state.meetings.addKrStatusData);
    const [showToastMessage, setShowToastMessage] = useState<any>(false);
    const [showToastMessageResult, setShowToastMessageResult] = useState<any>('');
    const {data:historyData,isLoading:historyDataLoading}:any=useGetKeyResultAttachment(kresultId,meetingId);
    const { mutate: delteCm, data: deleteCmData } = useDeleteAttachment();
    const [isSucces, SetIsSuccess] = useState<boolean>();
    const [tMessage, SetTMessage] = useState<string>();
    const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
    // const { mutate: addCheck, isSuccess,isLoading:AddChekinLoading,data:addCheckingData } = useAddCheckinMeeting();
    
    const evaluationData: AddEvalFace = {
      newValue: '',
      problems: '',
      nextState: '',
      meetingId: meetingId,
      teamId: teamId,
      periodId: periodId,
      tenantId: profileTenantId,
      keyResultId: kresultId,
      objectiveId: objectiveId,
      currentState: '',
      description: '',
      closedKeyResult: false
    }
    // {...evaluationData,newValue:initialNewValue,...initialValuesForm}
  const[selectedInitialValue,setSelectedInitialValue]=useState<any>(evaluationData)
  const [pointSystemsL,setPointSystemL]=useState<string>('');
  let{name,id}:any|null=objectiveManiInfo;
  let{name:KrNAme,responsibleName,startDate,startValue,threeTenthsValue,sevenTenthsValue,oneValue}:any=krMainInfo;
  const [selectedFile, setSelectedFile] = useState<any>({
    picture: null,
    imageName: '',
    title: '',
    url: '',
  });
  const [open, setOpen] = useState(false);
  const [authorizedFiles, setAuthorizedFiles] = useState<string | null>(null);
  const tenantId: string = useSelector((state: any) => state.meetings.profileTenantId);
//   const { data: personPictureData } = useGetTenantPicture(tenantId);

  const { mutate: addPersonImg, isLoading, data:addCheckingData, error } = useAddAttachment(() => {
    setSelectedFile({
      picture: null,
      imageName: '',
      title: '',
      url: '',
    });
  });

  const theme = useTheme();
  const fileRef = useRef<HTMLInputElement | null>(null);
  // const handleSetImages = (event: React.ChangeEvent<HTMLInputElement>) => {
  // const file = event.target.files ? event.target.files[0] : null;

  //   if (file) {
  //     if (file.type.includes("image/") && ["png", "jpeg", "jpg", "svg+xml"].includes(file.type.split("/")[1]) && file.size <= 4000000) {
  //       let imgFile = {
  //         picture: file,
  //         imageName: file.name,
  //         title: file.name,
  //         url: URL.createObjectURL(file),
  //       };
  //       setSelectedFile(imgFile);
  //       setAuthorizedFiles(null);
  //     } else {
  //       setAuthorizedFiles('فایل غیر مجاز است');
  //     }
  //   }
  // };
  const handleSetImages = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
  
    if (file) {
      if (file.type.includes("image/") && ["png", "jpeg", "jpg", "svg+xml"].includes(file.type.split("/")[1]) && file.size <= 200000) { // تغییر محدودیت حجم به 200 کیلوبایت
        let imgFile = {
          picture: file,
          imageName: file.name,
          title: file.name,
          url: URL.createObjectURL(file),
        };
        setSelectedFile(imgFile);
        setAuthorizedFiles(null);
      } else {
        setAuthorizedFiles('فایل غیر مجاز است');
      }
    }
  };
  

  const convertToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.picture);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleUpload = async () => {
    if (selectedFile.picture !== null) {
      try {
        const base64String = await convertToBase64(selectedFile);
        let body = {
          tenantId: tenantId,
          keyResultId:kresultId,
          meetingId:meetingId,
          extension: selectedFile.picture.type === "image/svg+xml" ? '.svg' : '.png',
          base64: base64String
        };
        await addPersonImg(body);
        setOpen(false);
        //setShowToastMessage("عملیات موفقیت‌آمیز بود");
      } catch (error) {
        console.error('Error uploading file:', error);
        //setShowToastMessage("خطای سرور: لطفاً دوباره تلاش کنید");
      }
    }
  };

  useEffect(() => {
    if (addCheckingData) {
      setChangeImgData(addCheckingData);
    }
  }, [addCheckingData]);

  useEffect(() => {
    if (error) {
      setShowToastMessage("خطای سرور: لطفاً دوباره تلاش کنید");
    }
  }, [error]);

  const initialCancel = (): void => {
    cancelo(false)
  }

  useEffect(() => {
  if (historyData) {
    let{base64,assessmentRate,score,keyResultMeetingHistoryDtos,assessmentHistory}=historyData;
    setImgSrrc(base64);
  }
  }, [historyData])

  // const [historyData, setHistoryData] = useState([
  //   { base64: 'data:image/png;base64,...', link: '' }, 
  //   { base64: 'data:image/png;base64,...', link: '' },
  //   // داده‌های نمونه
  // ]);

  useEffect(() => {
    let{id:krId,currentValue,problems,currentState,nextState,description,okR_KeyResultType,score}:any=krMainInfo;
    setPointSystemL(okR_KeyResultType);
    if (okR_KeyResultType==='مرحله ای') {
      let pureVal=score?.replace('%','');
      setTensileScore(pureVal)
    }
    let initValues={
      newValue:currentValue,
      problems:problems,
      currentState:currentState,
      nextState:nextState,
      description:description,
      tensileScore : okR_KeyResultType==='مرحله ای' ? score?.replace('%','') : ''
    }
    setFormIds((prev:any)=>({...prev,keyResultId:krId}));
    setSelectedInitialValue((prev:any)=>({...prev,...initValues}))
  }, [krMainInfo])
  

const { data: personPictureData } = useGetTenantPicture(tenantId);
const[imgSrrc,setImgSrrc]=useState<any>(null);
const [imgSrc, setImgSrc] = useState<string | null>(null);
const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
const [showImageSelector, setShowImageSelector] = useState<boolean>(false);
const [openLinkModal, setOpenLinkModal] = useState(false); // مدیریت باز بودن دیالوگ
const [link, setLink] = useState(''); // ذخیره لینک وارد شده توسط کاربر
const [savedLinks, setSavedLinks] = useState<string[]>([]); // آرایه‌ای برای ذخیره لینک‌ها
const [hoveredLinkIndex, setHoveredLinkIndex] = useState<number | null>(null); // مدیریت وضعیت قرارگیری ماوس

const openLinkModalHandler = () => setOpenLinkModal(true);
const closeLinkModalHandler = () => setOpenLinkModal(false);

const handleLinkSave = () => {
  let body = {
    tenantId: tenantId,
    keyResultId:kresultId,
    meetingId:meetingId,
    link:link
  };
  addPersonImg(body);
  setLink(''); 
  setOpenLinkModal(false);
};

const handleLinkDelete = (index: number) => {
  setSavedLinks((prevLinks) => prevLinks.filter((_, i) => i !== index)); 
};

const handleImageClick = () => {
    setShowImageSelector(true);
  };
  const handleImageChange = (newImgSrc: string) => {
    setImgSrc(newImgSrc);
    localStorage.setItem('tenantImage', newImgSrc); 
    setShowImageSelector(false);
  };

  const handleImageSelectorClose = () => {
    setShowImageSelector(false);
  };
useEffect(() => {
    // Load image from localStorage on component mount
    const savedImage = localStorage.getItem('tenantImage');
    if (savedImage) {
      setImgSrc(savedImage);
    } else if (personPictureData) {
      setImgSrc(personPictureData.pictureBase64String || null);
      localStorage.setItem('tenantImage', personPictureData.pictureBase64String || '');
    }
  }, [personPictureData]);

    useEffect(() => {
    if (addCheckingData) {
      if (addCheckingData?.data.isSuccess) {
         setShowToastMessage(true)
         setShowToastMessageResult(addCheckingData?.data.metaData.message);
         setAddEvalAsyncData(addCheckingData?.data)
         onsucces(false)
      } else {
        setShowToastMessageResult(addCheckingData?.data.metaData.message);
        setShowToastMessage(true);
      }   
  }
    }, [addCheckingData])

    const handleDeleteImage = (iddd: string) => {
      // const newHistoryData = [...historyData];
      // newHistoryData.splice(index, 1);
      // setImgSrrc(newHistoryData);
      let deleteBody = {
        deletedId: iddd,
        tenantId: tenantId,
      };
      delteCm(deleteBody);
      if(deleteCmData)
      {
        if(deleteCmData.data.isSuccess){
          // handleClos();
          setShowLtoastMessage(true);
          SetIsSuccess(true);
          SetTMessage(deleteCmData?.data.metaData.message);
        }else{
          // handleClos();
          setShowLtoastMessage(true);
          SetIsSuccess(false);
          SetTMessage(deleteCmData?.data.metaData.message);
        }
      }
    };
  
    // const handleLinkChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
    //   const newHistoryData = [...historyData];
    //   newHistoryData[index].link = event.target.value;
    //   setImgSrrc(newHistoryData);
    // };

    if (historyDataLoading) {
       return <Grid container  >
      <Box width={'100%'} py={5} textAlign={'center'} >
       <CircularProgress color='primary'   />
      </Box>
     </Grid>      
    }

  return (
    <Grid container  padding={1}>
    <Grid item xs={12}  >
        {
      historyDataLoading && <Grid container  >
       <Box width={'100%'} py={5} textAlign={'center'} >
        <CircularProgress color='primary'   />
       </Box>
      </Grid>
    }
    {
        <Grid item xs={12} md={12} py={1}>
        {/* <Box marginTop={1} marginBottom={2} marginRight={5} alignContent={'flex-end'}>
          <button
            onClick={() => setOpen(true)}
            style={{
              fontSize: 18,
              backgroundColor: theme.palette.primary.main,
              color: "#fff",
              // '&:hover': {
              //   backgroundColor: theme.palette.primary.dark,
              // },
              height:35,
              borderRadius: "6%",
              boxShadow: `0 4px 8px ${theme.palette.grey[600]}`,
            }}
          >
            <AddPhotoAlternateIcon /> آپلود تصویر
          </button>
        </Box> */}
              <Box
                    display="flex"
                    justifyContent="flex-end" 
                    marginBottom={2} 
                >
                    <button
                        onClick={() => setOpen(true)}
                        className={`btn px-6 text-sm font-thin text-white bg-[#00387c] btn-sm rounded-md`}
                    >
                        <AddPhotoAlternateIcon /> آپلود تصویر
                    </button>
                    <button 
                    className={`btn px-6 text-sm font-thin text-white bg-[#00387c] btn-sm rounded-md`}
                    onClick={openLinkModalHandler}>
                        اضافه کردن لینک
                   </button>
                </Box>
                <div style={{ padding: '20px' }}>
      {/* دیالوگ لینک */}
      <Dialog 
        open={openLinkModal} 
        onClose={closeLinkModalHandler} 
        maxWidth="sm" // حداکثر عرض دیالوگ
        fullWidth // استفاده از عرض کامل
      >
        <DialogTitle style={{ textAlign: 'center' }}>افزودن لینک</DialogTitle>
        <DialogContent>
          <TextField
            placeholder="https://example.com"
            fullWidth
            variant="outlined" // استفاده از استایل دیزاین شده
            value={link}
            onChange={(e) => setLink(e.target.value)}
            InputLabelProps={{
              shrink: true, // برای نمایش بهتر پلاسبولدر هنگام فوکوس
              style: { color: '#1976d2' }, // رنگ لیبل
            }}
            InputProps={{
              style: { padding: '10px' }, // تنظیم padding برای ورودی
            }}
            style={{ marginBottom: '10px' }} // فاصله پایین فیلد
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeLinkModalHandler}>بستن</Button>
          <Button color="primary" onClick={handleLinkSave}>ذخیره</Button>
        </DialogActions>
      </Dialog>
    </div>

            <Dialog 
                                open={open} 
                            onClose={() => setOpen(false)}
                            PaperProps={{ 
                            sx: { 
                                backgroundColor: theme.palette.background.paper, 
                                boxShadow: "0 6px 12px rgba(0, 0, 0, 0.2)",
                                width: "100%", 
                                maxWidth: "600px",
                                borderRadius: "16px",
                            } 
                            }}
                            maxWidth="sm"
                        >
                            <DialogTitle sx={{ padding: "16px", fontSize: "18px", fontWeight: "bold" }}>
                            افزودن
                            </DialogTitle>
                            <DialogContent sx={{ padding: "16px" }}>
                            <Stack
                                direction={"column"}
                                alignItems={"center"}
                                spacing={2}
                            >
                                <Button
                                variant={AddButtonVariant || "contained"}
                                color={addButtonColor || "primary"}
                                sx={{ px: "16px", borderRadius: "8px" }}
                                onClick={() => fileRef.current?.click()}
                                >
                                {imageSelectedType === 1 ? "انتخاب فایل" : "افزودن تصویر"}
                                </Button>
                                <input
                                hidden
                                ref={fileRef}
                                type="file"
                                accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                                onChange={(event) => {
                                    handleSetImages(event);
                                }}
                                />
                                {selectedFile.picture ? (
                                <Box
                                    sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: "100%",
                                    }}
                                >
                                    <img
                                    src={selectedFile.url}
                                    alt="Selected"
                                    style={{
                                        maxWidth: "100%",
                                        maxHeight: "400px",
                                        borderRadius: '8px',
                                        boxShadow: `0 4px 8px ${theme.palette.grey[400]}`,
                                        objectFit: 'contain',
                                        marginBottom: "16px",
                                    }}
                                    />
                                    <Stack
                                    direction={"row"}
                                    spacing={1}
                                    width={"100%"}
                                    justifyContent={"center"}
                                    >
                                    <IconButton
                                        onClick={() => setSelectedFile({
                                        picture: null,
                                        imageName: '',
                                        title: '',
                                        url: '',
                                        })}
                                        sx={{
                                        backgroundColor: "transparent",
                                        boxShadow: "none",
                                        '&:hover': {
                                            backgroundColor: theme.palette.error.light,
                                        }
                                        }}
                                    >
                                        <Delete />
                                    </IconButton>
                                    </Stack>
                                </Box>
                                ) : authorizedFiles !== null ? (
                                <Box
                                    textAlign={"center"}
                                    flexDirection={"column"}
                                    display={"flex"}
                                    alignItems={"center"}
                                    justifyContent={"center"}
                                    width={"100%"}
                                    height={"100%"}
                                >
                                    <Typography color={"red"} variant="button">
                                    {authorizedFiles}
                                    </Typography>
                                    <ErrorOutlineIcon color="error" />
                                </Box>
                                ) : (
                                <Stack
                                    direction={directionImageWrap || "column"}
                                    rowGap={2}
                                    alignItems={"center"}
                                    py={1}
                                >
                                    <Typography color={"gray"} fontSize={"12px"}>
                                    فایل‌های مجاز: PNG, JPEG, JPG, SVG
                                    </Typography>
                                    {disableSizeText ? "" : (
                                    <Typography
                                        color={"gray"}
                                        className="font-num"
                                        fontSize={"12px"}
                                    >
                                        حداکثر حجم: 200 کیلوبایت
                                        </Typography>
                                    )}
                                </Stack>
                                )}
                            </Stack>
                            </DialogContent>
                            <DialogActions sx={{ padding: "16px" }}>
                            <Button onClick={() => setOpen(false)} color="primary">
                                بستن
                            </Button>
                            <Button
                                disabled={selectedFile.picture === null || isLoading}
                                onClick={handleUpload}
                                endIcon={<SaveIcon />}
                                color="primary"
                            >
                                ذخیره
                            </Button>
                            </DialogActions>
        </Dialog>
        {/* <Box width={'80%'} 
        minHeight={'110px'} 
        borderRadius={2} 
        // boxShadow={3}  
        sx={{display:'flex',flexWrap:'wrap',justifyContent:'space-between',alignItems:'center'}}
        >
        <Box sx={{width:'40%',minHeight:'100px',display:'flex',flexDirection:'column',p:1,rowGap:1}}>
        <Box p={0.15} display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >نام:</Typography> <Typography variant='caption'  >{name}</Typography>  </Box>
        <Divider />
        </Box>

        <Box  sx={{width:'35%',minHeight:'100px',display:'flex',flexDirection:'column',p:1,rowGap:1}}>
        <Box p={0.15} display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >مسئول:</Typography> <Typography variant='caption'>{responsibleName}</Typography>  </Box>
        <Divider />
        <Box p={0.15} display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >تاریخ جلسه:</Typography> <Typography variant='caption'>{meetSelectedDate}</Typography>  </Box>
        <Divider />
        </Box>
        </Box> */}
         <Box
  width={'80%'}
  minHeight={'110px'}
  borderRadius={2}
  sx={{
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    ml: { xs: 0, sm: 10 }, // در موبایل حذف و در سایز بزرگ‌تر اعمال شود
  }}
>
<Box sx={{ width: '40%', minHeight: '100px', display: 'flex', flexDirection: 'column', p: 1, rowGap: 1 }}>
  <Box p={0.15} display="flex" columnGap={1} justifyContent="start" alignItems="center">
    <Typography variant="body2" fontSize="14px" fontWeight={700} lineHeight={1.5}>نام:</Typography>
    <Typography variant="body2" fontSize="12px" lineHeight={1.5}>{name}</Typography>
  </Box>
  <Divider />
  <Box p={0.15} display="flex" columnGap={1} justifyContent="start" alignItems="center">
    <Typography variant="body2" fontSize="14px" fontWeight={700} lineHeight={1.5}>مسئول:</Typography>
    <Typography variant="body2" fontSize="12px" lineHeight={1.5}>{responsibleName}</Typography>
  </Box>
  <Divider />
</Box>

<Box sx={{ width: '35%', minHeight: '100px', display: 'flex', flexDirection: 'column', p: 1, rowGap: 1 }}>
  <Box p={0.15} display="flex" columnGap={1} justifyContent="start" alignItems="center">
    <Typography variant="body2" fontSize="14px" fontWeight={700} lineHeight={1.5}>تاریخ جلسه:</Typography>
    <Typography variant="body2" fontSize="12px" lineHeight={1.5}>{meetSelectedDate}</Typography>
  </Box>
  {/* <Divider /> */}
  <Divider />
</Box>
</Box>


        </Grid>
    }
    {
    historyData && historyData.length > 0 && (
  //   <Grid container>
  //   {historyData.map((item: any, index: any) => (
  //     <Grid item xs={12} mx={'auto'} sx={{ bgcolor: '#F9F9F9' }} key={index}>
  //       <Box
  //         marginTop={1}
  //         marginBottom={2}
  //         marginRight={5}
  //         display={"flex"}
  //         justifyContent={"center"}
  //         alignItems={"center"}
  //       >
  //         <img
  //           src={item.base64}
  //           style={{ boxShadow: '20px' }}
  //           onClick={() => console.log("Image clicked")} // اگر می‌خواهید کلیک روی عکس را هندل کنید
  //         />
  //         <IconButton onClick={() => handleDeleteImage(item.id)} sx={{ marginLeft: 2 }}>
  //           <DeleteIcon />
  //         </IconButton>
  //         {/* <TextField
  //           label="Hyperlink"
  //           value={item.link}
  //           onChange={(event:any) => handleLinkChange(index, event)}
  //           sx={{ marginLeft: 2 }}
  //         /> */}
  //       </Box>
  //     </Grid>
  //   ))}
  // </Grid>
  <Grid container>
  {historyData.map((item: any, index: any) => (
    <Grid item xs={12} mx={'auto'} sx={{ bgcolor: '#F9F9F9' }} key={index}>
      <Box
        marginTop={1}
        marginBottom={2}
        // marginRight={5}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        position="relative" // برای قرار دادن ایکون حذف روی عکس
        onMouseEnter={() => setHoveredIndex(index)}
        onMouseLeave={() => setHoveredIndex(null)}
      >
        <img
          src={item.base64}
          style={{
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
            maxWidth: '100%',
            height: 'auto',
            cursor: 'pointer',
          }}
          onClick={() => console.log("Image clicked")}
        />
        {hoveredIndex === index && (
          <IconButton
            onClick={() => handleDeleteImage(item.id)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              '&:hover': {
                backgroundColor: "rgba(255, 0, 0, 0.8)",
                color: "#fff",
              },
            }}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Box>
      {item.link !== null && item.link !== '' && (
      <div 
        key={index} 
        style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}
        onMouseEnter={() => setHoveredLinkIndex(index)} // قرار گرفتن ماوس روی لینک
        onMouseLeave={() => setHoveredLinkIndex(null)} // خارج شدن ماوس از لینک
    >
        <Typography variant="body1">
            لینک ذخیره شده: 
            <a href={item.link} 
               target="_blank" 
               rel="noopener noreferrer" 
               style={{ color: 'blue', textDecoration: 'underline' }}>
                {item.link}
            </a>
        </Typography>
        {hoveredLinkIndex === index && ( // نمایش آیکون فقط زمانی که ماوس روی لینک قرار دارد
            <Button 
                onClick={() => handleLinkDelete(index)} 
                //style={{ marginLeft: '10px' }}
                >
                <DeleteIcon color="error" />
            </Button>
        )}
      </div>
    )}
         {/* نمایش لینک ذخیره شده به صورت هایپرلینک */}
         {/* {historyData.map((item: any, index: any) => (
    <div 
        key={index} 
        style={{ marginTop: '15px', display: 'flex', alignItems: 'center' }}
        onMouseEnter={() => setHoveredLinkIndex(index)} // قرار گرفتن ماوس روی لینک
        onMouseLeave={() => setHoveredLinkIndex(null)} // خارج شدن ماوس از لینک
    >
        <Typography variant="body1">
            لینک ذخیره شده: <a href={item.link} target="_blank" rel="noopener noreferrer" style={{ color: 'blue', textDecoration: 'underline' }}>{item.link}</a>
        </Typography>
        {hoveredLinkIndex === index && ( // نمایش آیکون فقط زمانی که ماوس روی لینک قرار دارد
            <Button 
                onClick={() => handleLinkDelete(index)} 
                style={{ marginLeft: '10px' }}>
                <DeleteIcon color="error" />
            </Button>
        )}
    </div>
))} */}

    </Grid>
  ))}
</Grid>
  )
}

    </Grid>

    {setShowToastMessage && (
          <DYToastMessage
            isSuccess={addCheckingData?.data.isSuccess}
            message={showToastMessageResult}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
         {showLtoastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )}
    </Grid>
  )
}
